<template>

  <v-container class="fill-height d-flex align-center justify-center">
    <v-row justify="center" align="center" class="text-center">
      <v-col cols="12" class="mb-8">
        <h1 class="text-h3 font-weight-bold mb-2">Bienvenido 👋</h1>
        <p class="text-subtitle-1 text-medium-emphasis">
          Este es el panel de administración. Selecciona una opción para continuar.
        </p>
      </v-col>

      <v-col cols="12" sm="6" md="4" class="d-flex">
        <v-card class="pa-6 rounded-xl elevation-4 mx-auto" hover>
          <v-card-title class="justify-center">
            <v-icon size="40" color="primary" class="mr-2">mdi-warehouse</v-icon>
            <span class="text-h6 font-weight-bold">Ver Stock</span>
          </v-card-title>
          <v-card-text class="text-body-2">
            Consulta y administra el inventario disponible en el sistema.
          </v-card-text>
          <v-card-actions class="justify-center mt-4">
            <RouterLink to="/vista-stock">
              <v-btn color="primary" size="large" rounded>Ir</v-btn>
            </RouterLink>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="4" class="d-flex">
        <v-card class="pa-6 rounded-xl elevation-4 mx-auto" hover>
          <v-card-title class="justify-center">
            <v-icon size="40" color="secondary" class="mr-2">mdi-file-excel</v-icon>
            <span class="text-h6 font-weight-bold">Exportar Excel</span>
          </v-card-title>
          <v-card-text class="text-body-2">
            Genera y descarga reportes de productos en formato Excel.
          </v-card-text>
          <v-card-actions class="justify-center mt-4">
            <RouterLink to="/Excel-export">
              <v-btn color="secondary" size="large" rounded>Exportar</v-btn>
            </RouterLink>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { VContainer, VRow, VCol, VBtn, VCard, VCardTitle, VCardText, VCardActions, VIcon } from 'vuetify/components'
import { RouterLink } from 'vue-router'
export default {
  name: 'DashboardView',
  components: {
    VContainer,
    VRow,
    VCol,
    VBtn,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VIcon,
    RouterLink,
  },
}
</script>
